////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const initKioskCreationAddItems = {
	postKioskCreationItems: (filters = {}, requestId, queryParams = { page: '0', size: '250' }) => ({
		type: ActionsTypes.POST_KIOSK_ADD_ITEMS,
		payload: {
			filters,
			requestId,
			queryParams,
		},
	}),
	postKioskCreationItemsSuccess: (data) => ({
		type: ActionsTypes.POST_KIOSK_ADD_ITEMS_SUCCESS,
		payload: {
			data,
		},
	}),
	postKioskCreationItemsFailure: (error) => ({
		type: ActionsTypes.POST_KIOSK_ADD_ITEMS_FAILURE,
		payload: {
			error,
		},
	}),

	putKioskLinkItems: (requestId, itemId) => ({
		type: ActionsTypes.PUT_KIOSK_LINK_ITEMS,
		payload: {
			requestId,
			itemId,
		},
	}),
	putKioskLinkItemsSuccess: (data) => ({
		type: ActionsTypes.PUT_KIOSK_LINK_ITEMS_SUCCESS,
		payload: {
			data,
		},
	}),
	putKioskLinkItemsFailure: (error) => ({
		type: ActionsTypes.PUT_KIOSK_LINK_ITEMS_FAILURE,
		payload: {
			error,
		},
	}),

	putKioskUnlinkItems: (requestId, distriItemId) => ({
		type: ActionsTypes.PUT_KIOSK_UNLINK_ITEMS,
		payload: {
			requestId,
			distriItemId,
		},
	}),
	putKioskUnlinkItemsSuccess: (data) => ({
		type: ActionsTypes.PUT_KIOSK_UNLINK_ITEMS_SUCCESS,
		payload: {
			data,
		},
	}),
	putKioskUnlinkItemsFailure: (error) => ({
		type: ActionsTypes.PUT_KIOSK_UNLINK_ITEMS_FAILURE,
		payload: {
			error,
		},
	}),

	getKioskItemsValidate: (requestId, redirectTest) => ({
		type: ActionsTypes.GET_KIOSK_ITEMS_VALIDATE,
		payload: {
			requestId,
			redirectTest,
		},
	}),
	getKioskItemsValidateSuccess: (data) => ({
		type: ActionsTypes.GET_KIOSK_ITEMS_VALIDATE_SUCCESS,
		payload: {
			data,
		},
	}),
	getKioskItemsValidateFailure: (error) => ({
		type: ActionsTypes.GET_KIOSK_ITEMS_VALIDATE_FAILURE,
		payload: {
			error,
		},
	}),

	resetDataAddItems: () => ({
		type: ActionsTypes.RESET_DATA_ADD_ITEMS,
	}),
}

export default initKioskCreationAddItems
